import React from 'react';
import { TableCell, TableRow, TextField, Checkbox, Select, MenuItem, FormControl } from '@material-ui/core';
import { KeyboardTimePicker } from '@material-ui/pickers';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import Icon from '../../../components/Icon/Icon';

export default function RaceRow({ children, race, onChange, onError }: any) {
  const { t } = useTranslation('common');

  return (
    <>
      <TableRow>
        <TableCell className="add-meeting-form__cell">00000</TableCell>
        <TableCell className="add-meeting-form__cell">{ t('addMeetingForm.race') } { race.id + 1 }</TableCell>
        <TableCell className="add-meeting-form__cell">
          <KeyboardTimePicker
            className="add-meeting-form__input add-meeting-form__input--full-width"
            name="startTime"
            value={ race.scheduledTime }
            inputValue={ race.scheduledTime }
            onChange={ date => onChange('scheduledTime', race, date, true) }
            placeholder="hh:mm"
            format="HH:mm"
            inputVariant="outlined"
            variant="inline"
            orientation="landscape"
            ampm={ false }
            required
            onError={ (error) => onError('startTime', error.toString()) }
          />
        </TableCell>
        <TableCell className="add-meeting-form__cell">
          <TextField
            variant="outlined"
            className="add-meeting-form__input add-meeting-form__input--full-width"
            name="numberRaces"
            type="number"
            inputProps={ { min: '0', step: '1' } }
            value={ race.runnerCount }
            onChange={ e => onChange('runnerCount', race, e.target.value) }
            required
          />
        </TableCell>
        <TableCell className="add-meeting-form__cell">
          <Checkbox
            name="checkBoxSelected"
            color="primary"
            className="add-meeting-form__icon"
            checked={ race.autoClose }
            onChange={ () => onChange('autoClose', race, !race.autoClose) }
            icon={ <Icon icon="checkboxSmall" className="add-meeting-form__icon" /> }
            checkedIcon={
              <Icon
                icon="checked"
                className="add-meeting-form__icon"
              />
            }
          />
        </TableCell>
        <TableCell className="add-meeting-form__cell">
          <Checkbox
            name="checkBoxSelected"
            color="primary"
            className="add-meeting-form__icon"
            checked={ race.rule4 }
            onChange={ () => onChange('rule4', race, !race.rule4) }
            icon={ <Icon icon="checkboxSmall" className="add-meeting-form__icon" /> }
            checkedIcon={
              <Icon
                icon="checked"
                className="add-meeting-form__icon"
              />
            }
          />
        </TableCell>
        <TableCell className="add-meeting-form__cell">
          <TextField
            variant="outlined"
            className="add-meeting-form__input add-meeting-form__input--full-width"
            name="numberRaces"
            type="number"
            value={ race.places }
            onChange={ e => onChange('places', race, e.target.value) }
            required
          />
        </TableCell>
        <TableCell className="add-meeting-form__cell">
          <div className="add-meeting-form__container">
            <FormControl variant="outlined">
              <Select
                className="add-meeting-form__input add-meeting-form__input--full-width"
                name="status"
                value={ race.status }
                onChange={ e => onChange('status', race, e.target.value) }
                required
              >
                <MenuItem value="open">{ t('addMeetingForm.open') }</MenuItem>
                <MenuItem value="noBets">{ t('addMeetingForm.noBets') }</MenuItem>
              </Select>
            </FormControl>
            <Icon
              icon="dropdownArrow"
              className={
                classNames({
                  'add-meeting-form__dropdown': true,
                  'add-meeting-form__dropdown--closed': race.runners.length !== 0 && !race.isOpen
                })
              }
              onClick={ () => onChange('isOpen', race, !race.isOpen) }
            />
          </div>
        </TableCell>
      </TableRow>
      { children }
    </>
  );
}
